type LoadScriptOptions = {
  async?: boolean;
  defer?: boolean;
  id?: string;
};

const cache = new Map<string, Promise<void>>();

export const loadScript = (src: string, options: LoadScriptOptions = {}): Promise<void> => {
  if (typeof document === 'undefined') {
    return Promise.reject(new Error('loadScript는 브라우저 환경에서만 동작합니다.'));
  }

  const cached = cache.get(src);
  if (cached) {
    return cached;
  }

  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = options.async ?? true;
    if (options.defer) {
      script.defer = true;
    }
    if (options.id) {
      script.id = options.id;
    }

    const cleanup = () => {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
    };
    const onLoad = () => {
      cleanup();
      resolve();
    };
    const onError = () => {
      cleanup();
      script.remove();
      cache.delete(src);
      reject(new Error(`스크립트 로드 실패: ${src}`));
    };
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);
    document.head.appendChild(script);
  });

  cache.set(src, promise);
  return promise;
};
